module.exports = __webpack_public_path__ + "img/02郭垣辰.3ece088e.jpg";